import { render, staticRenderFns } from "./clients.component.vue?vue&type=template&id=7f088be8&scoped=true&lang=html&"
import script from "./clients.component.vue?vue&type=script&lang=js&"
export * from "./clients.component.vue?vue&type=script&lang=js&"
import style0 from "./clients.component.vue?vue&type=style&index=0&id=7f088be8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f088be8",
  null
  
)

export default component.exports